// src/hooks/useOnlineStatus.js
//
// Phase 5 — Tiny hook that tracks the browser online/offline state.
// The Firestore SDK already queues writes locally via its IndexedDB
// cache (see src/firebase/config.js), so this hook is only used to
// surface a visible badge in the AppBar. It intentionally stays
// framework-free and is easy to unit test.

import { useEffect, useState } from 'react';

const getInitialStatus = () => {
  if (typeof navigator === 'undefined') return true;
  return navigator.onLine !== false;
};

const useOnlineStatus = () => {
  const [online, setOnline] = useState(getInitialStatus);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return online;
};

export default useOnlineStatus;
